module.exports = __webpack_public_path__ + "img/Schlürf.f9c0da9a.svg";